var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardLayout',[_c('LoggedIssuesBody',{attrs:{"reversals":_vm.reversals,"loggedReversals":_vm.loggedReversals,"grandTotalReversal":_vm.grandTotalReversal,"totalCurrentMonthReversal":_vm.totalCurrentMonthReversal,"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }